// PLACEHOLDER PRICES — set real prices here.
// These are illustrative only. Update `price` (and any limits) before launch,
// and keep them in sync with the Stripe price IDs in .env
// (STRIPE_BETTOR_PRICE_ID / STRIPE_SCOUT_PRICE_ID).

export interface Plan {
  id: 'bettor' | 'scout' | 'custom'
  name: string
  /** Display price, e.g. "€29" or "Contact us". */
  price: string
  /** Billing period suffix, e.g. "/mo". Empty for custom. */
  period: string
  tagline: string
  highlighted?: boolean
  badge?: string
  features: string[]
  cta: string
}

export const PLANS: Plan[] = [
  {
    id: 'bettor',
    name: 'Bettor',
    price: '€29',
    period: '/mo',
    tagline: 'For single-book bettors getting started with entity resolution.',
    features: [
      '3 requests / second',
      '5 names per call',
      '2 data sources',
      '50 events per source',
      'All 8 sports',
      'Feedback loop (report FP/FN)',
    ],
    cta: 'Get started',
  },
  {
    id: 'scout',
    name: 'Scout',
    price: '€99',
    period: '/mo',
    tagline: 'For serious arbitrage and multi-book fixture matching.',
    highlighted: true,
    badge: 'Most popular',
    features: [
      '15 requests / second',
      '25 names per call',
      '5 data sources',
      '500 events per source',
      'All 8 sports',
      'Priority support',
    ],
    cta: 'Get started',
  },
  {
    id: 'custom',
    name: 'Custom',
    price: 'Contact us',
    period: '',
    tagline: 'Tailored limits for high-volume operations.',
    features: [
      'Tailored rate limits',
      'Up to 200 data sources',
      'Up to 5,000 events per source',
      'Dedicated onboarding',
      'SLA on request',
    ],
    cta: 'Contact us',
  },
]
